import React from 'react';
import { Dialog, DialogContent, DialogTitle, Button, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalTitle } from 'components/index';

import styles from './FileIdDialog.module.scss';

type Props = {
  fileId: string;
  onConfirm: (copiedValue: string) => void;
  onCancel: () => void;
};

const FileIdDialog = ({ fileId, onConfirm, onCancel }: Props) => {
  const { t } = useTranslation('settings');
  const displayFileId = fileId.startsWith('Clinic/') ? `Shared/${fileId.slice('Clinic/'.length)}` : fileId;

  return (
    <Dialog open onClose={onCancel} className={styles.dialog}>
      <DialogTitle>
        <ModalTitle title={t('documentsCommon.fileIdUpper')} onClose={onCancel} />
      </DialogTitle>

      <DialogContent>
        <Typography variant='body2' component='p' sx={{ mb: 1 }}>
          {t('dialogs.fileIdDescription')}
        </Typography>

        <TextField
          fullWidth
          value={displayFileId}
          variant='outlined'
          sx={{ mb: 2 }}
          InputProps={{
            readOnly: true,
          }}
        />

        <Stack direction='row' alignItems='center' className={styles.actionsRow}>
          <Button variant='outlined' fullWidth className={styles.formButton} onClick={onCancel}>
            {t('documentsCommon.close')}
          </Button>
          <Button variant='contained' fullWidth className={styles.formButton} onClick={() => onConfirm(fileId)}>
            {t('documentsCommon.copy')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default FileIdDialog;
